import { ReactNode } from 'react';
import { PrefillContextProvider } from 'src/context/prefill-context';
import { usePrefillApplication } from 'src/helpers/usePrefillApplication';

interface PrefillApplicationProviderProps {
  children: ReactNode;
}

export function PrefillApplicationProvider({
  children,
}: PrefillApplicationProviderProps) {
  usePrefillApplication();

  return <PrefillContextProvider>{children}</PrefillContextProvider>;
}
